import { CloseOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationTriangle,
  faCheckCircle,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const AlertWrapper = styled.div`
  position: relative;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-left: 4px solid #e82424;

  .close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
    color: #999;
    font-size: 14px;
    &:hover {
      color: #333;
    }
  }

  .alert-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 12px;

    .warning-icon {
      color: #e82424;
      font-size: 20px;
    }

    .title {
      font-family: Lato, sans-serif;
      font-size: 20px;
      font-weight: 700;
      color: #000;
      margin: 0;
    }
  }

  .alert-message {
    font-family: Lato, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #555;
    margin: 0 0 12px 0;
    padding-right: 24px;
  }

  .waiver-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 4px;
    font-family: Lato, sans-serif;
    font-size: 13px;
    font-weight: 600;

    &.has-waiver {
      background: #f6ffed;
      border: 1px solid #b7eb8f;
      color: #389e0d;
    }

    &.no-waiver {
      background: #fff2f0;
      border: 1px solid #ffccc7;
      color: #cf1322;
    }
  }
`;

interface Props {
  alertContent: string | null;
  hasMealWaiver: boolean;
  setAlertContent: (val: string | null) => void;
}

const MealWaiverAlert: React.FC<Props> = ({
  alertContent,
  hasMealWaiver,
  setAlertContent
}) => {
  return (
    <AlertWrapper>
      <CloseOutlined
        className="close-btn"
        onClick={() => setAlertContent(null)}
      />
      <div className="alert-header">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className="warning-icon"
        />
        <p className="title">Attention</p>
      </div>
      <p className="alert-message">{alertContent}</p>
      <div
        className={`waiver-status ${
          hasMealWaiver ? 'has-waiver' : 'no-waiver'
        }`}
      >
        <FontAwesomeIcon icon={hasMealWaiver ? faCheckCircle : faTimesCircle} />
        {hasMealWaiver
          ? 'Provider has meal waiver'
          : 'Provider does NOT have meal waiver'}
      </div>
    </AlertWrapper>
  );
};

export default MealWaiverAlert;
